import { Stringable } from './Stringable';
import collect from 'collect.js';

interface Address {
  street_name?: string;
  street_number?: string;
  city?: string;
  state?: string;
  country?: string;
  zip_code?: string;
  note?: string;
}

export default class AddressHelpers {
  private static country: string;

  public static setCountry(country: string): AddressHelpers {
    AddressHelpers.country = country;

    return new AddressHelpers();
  }

  public format(props: Address): string {
    return AddressHelpers.format(props);
  }

  public static format({ street_name, street_number, city, state, country, zip_code, note }: Address): string {
    const address =
      {
        US: this.implode([this.implode([street_number, street_name], ' '), note, city, state, zip_code]),
      }[country ?? AddressHelpers.country] ??
      this.implode([this.implode([street_name, street_number], ' '), this.implode([zip_code, city], ' ')]);

    return new Stringable(address).squish().toString();
  }

  private static implode(fields: string[], glue: string = ', '): string {
    return collect(fields)
      .filter((item) => item && item.length > 0)
      .implode(glue)
      .trim();
  }
}
